import {
  cloneElement,
  MouseEventHandler,
  ReactElement,
  useEffect,
  useRef,
} from 'react';
import { useVisitor } from '../context/visitorContext';
import { APIEvents } from '../core/constants';
import { useAppSelector } from '../hooks';
import { useSendEvent } from '../hooks/useSendEvent';

const CTRObserver = ({
  children,
  viewEvent = APIEvents.view_cta,
  clickEvent = APIEvents.click_cta,
  blockKey,
  trackClick = true,
}: {
  children: ReactElement;
  blockKey: string;
  viewEvent?: string;
  clickEvent?: string;
  trackClick?: boolean;
}) => {
  const ref = useRef<HTMLElement>();
  const { visitorId } = useVisitor();
  const userId = useAppSelector((s) => s.user.user?.AmazonCognitoId);
  const { sendEvent: sendViewEvent } = useSendEvent(blockKey, viewEvent);
  const { sendEvent: sendClickEvent } = useSendEvent(blockKey, clickEvent);

  useEffect(() => {
    if (ref.current && (userId || visitorId)) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              sendViewEvent();
            }
          });
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 1,
        }
      );

      observer.observe(ref.current);

      return () => {
        observer.disconnect();
      };
    }
    // eslint-disable-next-line
  }, [userId, visitorId]);

  return cloneElement(children, {
    ...children.props,
    ...(trackClick
      ? {
          onClick: !!(children.props.onClick as MouseEventHandler)
            ? (((e) => {
                children.props.onClick(e);
                sendClickEvent();
              }) as MouseEventHandler)
            : sendClickEvent,
        }
      : {}),
    ref,
  });
};

export default CTRObserver;
